import React from 'react';

import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/IntentsPage';
import block from 'propmods';

import { GrammarIntentTestResult } from '../../model/grammar';

import './GrammarPageTestResult.scss';

const t = i18n(keyset);
const b = block('GrammarPageTestResult');

interface GrammarPageTestResultsProps {
    results: GrammarIntentTestResult;
}

export const GrammarPageTestResult: React.FC<GrammarPageTestResultsProps> = ({ results }) => {
    const { trueNegatives, truePositives, falseNegatives, falsePositives, precision, recall } = results;
    const showPositiveSection = truePositives.length > 0 || falseNegatives.length > 0;
    const showNegativeSection = trueNegatives.length > 0 || falsePositives.length > 0;

    return (
        <div {...b()}>
            <div>
                {t('test-result-occuracy')} {Math.round(precision * 100)}%
            </div>
            <div>
                {t('test-result-completeness')} {Math.round(recall * 100)}%
            </div>
            <br />
            {showPositiveSection && (
                <>
                    <div {...b('title')}>{t('test-result-positive')}</div>
                    {truePositives.map(({ text }, i) => (
                        <div {...b('line', { matched: true })} key={i}>
                            {text}
                        </div>
                    ))}
                    {falseNegatives.map(({ text }, i) => (
                        <div {...b('line', { matched: false })} key={i}>
                            {text}
                        </div>
                    ))}
                    <br />
                </>
            )}
            {showNegativeSection && (
                <>
                    <div {...b('title')}>{t('test-result-negative')}</div>
                    {trueNegatives.map(({ text }, i) => (
                        <div {...b('line', { matched: true })} key={i}>
                            {text}
                        </div>
                    ))}
                    {falsePositives.map(({ text }, i) => (
                        <div {...b('line', { matched: false })} key={i}>
                            {text}
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};
